module.exports = __webpack_public_path__ + "img/icons B_31.f585fcbe.png";